import { mapActions } from 'vuex'

export const alertsMixin = {
  methods: {
    ...mapActions('dialogs', ['openConfirm', 'showLoading', 'hideLoading']),
    alertError (message) {
      this.$notify({
        text: message,
        duration: 20000,
        type: 'error'
      })
    },
    alertSuccess (message) {
      this.$notify({
        text: message,
        duration: 10000,
        type: 'success'
      })
    },
    alertInfo (message) {
      this.$notify({
        text: message,
        duration: 10000
      })
    },
    alertWarning (message) {
      this.$notify({
        text: message,
        duration: 10000,
        type: 'warn'
      })
    }
  }
}

export default alertsMixin
